<template>
  <div class="page">
    <!--导航栏-->
    <nav-bar back-color="#438eb9" title-color="#fff"></nav-bar>
    <!--主体-->
    <el-container class="mr0At" style="width: 95%;height: 90vh;">
      <!--侧边栏-->
      <el-aside width="auto" style="background: #f0f0f0">
        <!--展开 折叠-->
        <!--<div class="difcac mrBtm10 mrTop10" style="width: 6.4rem;">
          <el-switch v-model="isCollapse"></el-switch>
        </div>-->
        <el-menu
          :collapse="!isCollapse"
          mode="vertical"
          :default-active="current"
          class="el-menu-vertical"
          background-color="#f0f0f0"
          router
        >
          <el-menu-item index="/">
            <i class="el-icon-menu"></i>
            <span slot="title">首页</span>
          </el-menu-item>
          <el-menu-item index="/infoCenter/sign">
            <i class="el-icon-menu"></i>
            <span slot="title">开始报名</span>
          </el-menu-item>
          <el-menu-item index="/infoCenter/profile">
            <i class="el-icon-menu"></i>
            <span slot="title">修改信息</span>
          </el-menu-item>
          <el-menu-item index="/infoCenter/check">
            <i class="el-icon-menu"></i>
            <span slot="title">查看信息</span>
          </el-menu-item>
          <el-menu-item index="/infoCenter/updateinfo">
            <i class="el-icon-menu"></i>
            <span slot="title">上传资料</span>
          </el-menu-item>
          <el-menu-item index="/infoCenter/result">
            <i class="el-icon-menu"></i>
            <span slot="title">审核查询</span>
          </el-menu-item>
        </el-menu>
      </el-aside>
      <!--内容-->
      <el-main class="bgff">
        <router-view></router-view>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
export default {
  name: "infoCenter",
  components: {NavBar},
  data() {
    return {
      current: '/infoCenter/sign',
      isCollapse: true,//是否展开
    }
  },
  methods: {

  },
  activated() {
    this.current = this.$route.path //获取当前页面路由
  },
  watch: {
    //监听路由
    '$route.path':function (newValue) {
      this.current = newValue
    }
  },
}
</script>

<style scoped>
  .page{
    padding-top: 4.8rem;
  }
  .el-menu-vertical:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
  }
  ::v-deep.el-menu-item.is-active{
    background: #fff !important;
  }
  ::v-deep.el-menu-item{
    border-bottom: 1px solid #ccc;
  }
</style>